export { default } from './Slider'
export * from './types';
